import { Suspense, lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router'

import { Loading } from '@ankor-io/ui-components'

import App from '@/App'
import { DashboardPage } from '@/views/pages/DashboardPage'
import NotFound from '@/views/pages/NotFound'
import { SignInPage } from '@/views/pages/SignInPage'
import { FeatureFlags } from '@/views/pages/feature-flags/feature-flags'
import OrganizationDetails from '@/views/pages/organizations/organization-details'
import { OrganizationIntegrationsPage } from '@/views/pages/organizations/organization-integrations'
import { OrganizationPipelinesPage } from '@/views/pages/organizations/organization-pipelines'
import { OrganizationPricing } from '@/views/pages/organizations/organization-pricing'
import OrganizationVessels from '@/views/pages/organizations/organization-vessels'
import Organizations from '@/views/pages/organizations/organizations'
import { Pricing } from '@/views/pages/pricing/pricing'

// Lazy so the AI SDK and the markdown renderer stay out of the main bundle
const BanjoPage = lazy(() => import('@/views/pages/banjo/banjo').then((m) => ({ default: m.BanjoPage })))

export function Router() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Routes>
          {/* Auth Pages - NO Layout Wrapper */}
          <Route
            path="/sign-in"
            element={<SignInPage />}
          />

          {/* App Routes WITH Layout */}
          <Route element={<App />}>
            <Route
              path="/"
              element={<DashboardPage />}
            />
            <Route
              path="/organizations"
              element={<Organizations />}
            />
            <Route
              path="/organizations/:id"
              element={<OrganizationDetails />}
            />
            <Route
              path="/organizations/:id/pricing"
              element={<OrganizationPricing />}
            />
            <Route
              path="/organizations/:id/integrations"
              element={<OrganizationIntegrationsPage />}
            />
            <Route
              path="/organizations/:id/pipelines"
              element={<OrganizationPipelinesPage />}
            />
            <Route
              path="/organizations/:id/vessels"
              element={<OrganizationVessels />}
            />
            <Route
              path="/feature-flags"
              element={<FeatureFlags />}
            />
            <Route
              path="/pricing"
              element={<Pricing />}
            />
            <Route
              path="/banjo"
              element={<BanjoPage />}
            />

            {/* 404 Catch-all Route - Must be last */}
            <Route
              path="*"
              element={<NotFound />}
            />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}
